export default __webpack_public_path__ + "static/media/id-card-black.46fcb2d2.svg";